// extracted by mini-css-extract-plugin
export default {"heading":"Addresses_heading__b2SjP","description":"Addresses_description__57rrp","addButton":"Addresses_addButton__3DME6","addButtonEmpty":"Addresses_addButtonEmpty__4gx0f"};